module.exports = __webpack_public_path__ + "img/empty-state-bg.e27ba3fd.png";